"use client"
import React from 'react'
import Navbar from '../../components/admin/common/Navbar'
import MainMarketing from '../../components/admin/marketing/MainMarketing'

const Marketing = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="p-4 md:p-8">
        <MainMarketing/>
      </main>
    </div>
  )
}

export default Marketing
